(function() {
  // ===============================================================
  // CONFIGURATION & UTILITIES
  // ===============================================================
  
  const DEBUG_MODE = true; // Set to false for production use

  /**
   * Internal logging helper for debugging tracking flow
   */
  function log(message, data = "") {
    if (DEBUG_MODE) console.log(`[Tracking Debug]: ${message}`, data);
  }

  /**
   * Primary function to dispatch Lead events to Meta and DataLayer
   * @param {string} source - Identifies where the lead originated from
   */
  async function fireLeadEvent(source) {
    // Prevent duplicate firing on the same page load/session
    if (window.tempramed_lead_fired) return;
    window.tempramed_lead_fired = true;

    log(`Attempting to fire Lead event from: ${source}`);

    // 1. Meta (Facebook) Pixel
    // We check if the 'fbq' object exists to avoid reference errors
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead');
      log("✅ 'Lead' event successfully sent to Meta Pixel.");
    } else {
      console.warn("⚠️ Meta Pixel (fbq) not detected. Ensure base code is installed.");
    }

    // 2. DataLayer (Google Tag Manager)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'tempramed:lead_generated',
      'source': source,
      'hashedEmail': 'DISABLED_FOR_TESTING'
    });
    log("✅ Event pushed to DataLayer.");
    
    // Clean up storage to prevent re-firing on manual page refresh
    sessionStorage.removeItem('tempramed_temp_email');
  }

  // ===============================================================
  // 1. LISTENERS: PRE-RELOAD CAPTURE
  // ===============================================================
  document.addEventListener('submit', function(e) {
    const form = e.target;
    // Targeting common Shopify and Klaviyo email input names
    const emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
    
    if (emailInput && emailInput.value) {
      log("Submission intent detected. Setting temporary flag in sessionStorage.");
      sessionStorage.setItem('tempramed_temp_email', 'true'); 
    }
  }, true);

  // ===============================================================
  // 2. POST-RELOAD LOGIC: URL ANALYSIS
  // ===============================================================
  window.addEventListener('load', function() {
    const params = new URLSearchParams(window.location.search);
    const storedEmailFlag = sessionStorage.getItem('tempramed_temp_email');

    // Only proceed if a form submission was flagged in the previous step
    if (storedEmailFlag) {
      log("Submission flag found. Analyzing URL parameters...");

      // Case A: Shopify Newsletter/Registration (typically returns ?customer_posted=true)
      if (params.get('customer_posted') === 'true' || window.location.href.includes('newsletter')) {
        fireLeadEvent('Shopify Newsletter/Form');
      } 
      // Case B: Shopify Contact Page (typically returns ?contact_posted=true)
      else if (params.get('contact_posted') === 'true') {
        fireLeadEvent('Contact Page Form');
      }
      // Case C: Fallback for generic Shopify forms
      else if (window.location.search.includes('form_type=')) {
        fireLeadEvent('Generic Shopify Form');
      }
    }
  });

  // ===============================================================
  // 3. KLAVIYO (AJAX SUBMISSIONS)
  // ===============================================================
  // Klaviyo forms often don't reload the page, so we listen for their custom event
  window.addEventListener('klaviyoForms', function(e) {
    if (e.detail.type === 'submit') {
      log("Klaviyo submission event detected.");
      fireLeadEvent('Klaviyo Form');
    }
  });

})();